import PropTypes from 'prop-types';

export const ProductDefaultProps = {
  deliverableQuantity: null,
  deliveredQuantity: null,
  deliveredQuantityLabel: null,
  id: null,
  label: null,
  orderedQuantity: null,
  productBrand: null,
  productId: null,
  productPrice: null,
  returnedQuantity: null,
  saleUnit: null,
  salesPackaging: null,
  shippingDelay: null,
  splitPackaging: false,
  supplierReference: null,
  totalLineAmount: null,
  weeeTaxAmount: null,
  weeeTotalTaxAmount: null,
};

export const ProductPropTypes = {
  deliverableQuantity: PropTypes.number,
  deliveredQuantity: PropTypes.number,
  deliveredQuantityLabel: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  orderedQuantity: PropTypes.number,
  productBrand: PropTypes.string,
  productId: PropTypes.string,
  productPrice: PropTypes.number,
  returnedQuantity: PropTypes.number,
  saleUnit: PropTypes.string,
  salesPackaging: PropTypes.number,
  shippingDelay: PropTypes.string,
  splitPackaging: PropTypes.bool,
  supplierReference: PropTypes.string,
  totalLineAmount: PropTypes.number,
  weeeTaxAmount: PropTypes.number,
  weeeTotalTaxAmount: PropTypes.number,
};
